import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import AddAcademyPartners from "./AddAcademyPartners";
import WebService from "../../utility/WebService";

const AcademyPartners = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [data, setData] = useState<any>(null);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        getData();
    }, [])

    const getData = () => {
        setLoading(true);
        WebService.getAPI({
            action: `academy-partners/getContent`
        })
            .then((res: any) => {
                setData(res.data);
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    }

    return (
        <>
            <AddAcademyPartners
                show={showAddModal}
                handleClose={() => {
                    setShowAddModal(false)
                    getData();
                }}
                data={data}
            />
            <div className="events-main">
                <Card className='event-card'>
                    {
                        isLoading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 100 }}>
                                <span className="spinner-border" role="status" aria-hidden="true"></span>
                            </div>
                        ) :
                            <>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div className='page-title'>Academy Partners</div>
                                    <CustomButton
                                        isLoading={false}
                                        label={data ? 'Edit' : 'Add'}
                                        onClick={() => {
                                            setShowAddModal(true);
                                        }}
                                        style={{ width: 100 }}
                                    />
                                </div>
                                {
                                    data ? (
                                        <div className="mt-3">
                                            <div>{data.title}</div>
                                            <div className="mt-1">{data.subtitle}</div>
                                            <div className="mt-3">
                                                <strong>Logos:</strong>
                                                <div className="d-flex flex-wrap mt-2">
                                                    {
                                                        data.logos && data.logos.length > 0 ? data.logos.map((item: any, index: number) => (
                                                            <div key={index} className="me-3 mb-3" style={{ width: 100, height: 100, border: '1px solid #ccc', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                                                                <img src={item.file} alt={`Logo ${index + 1}`} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                                                            </div>
                                                        )) : <p>No logos available</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ) : null
                                }
                            </>
                    }
                </Card>
            </div>
        </>
    )
}

export default AcademyPartners;